/** Whether the AI chat widget is enabled for this build. */
export const isChatWidgetEnabled = import.meta.env.VITE_ENABLE_CHAT_WIDGET === 'true'
